module.exports = __webpack_public_path__ + "54cf98f5/img/question-icon.06c20c5d.svg";